import React, {
    createContext, useState, useMemo, 
   } from 'react';
   import PropTypes from 'prop-types';
   
   export const SideBarRefreshContext = createContext();
   
   const SideBarRefreshContextProvider = ({ children }) => {
    const [sideBarRefresh, setSideBarRefresh] = useState({
        adminAgentRefresh: false,
        adminAgentRequestRefresh: false,
        adminAgentRejectedRefresh: false,
        adminRestaurantRefresh: false,
        adminRestaurantRequestRefresh: false,
        adminRestaurantRejectedRefresh: false,
        adminMealRefresh: false,
        adminMealRequestRefresh: false,
        adminMealRejectedRefresh: false,
        adminBookingRefresh: false,
        adminTripRefresh: false,
        adminAccountRefresh: false,
        adminAccountApprovedRefresh: false,
        adminAccountRejectedRefresh: false,
        adminAccountPendingApprovalRefresh: false,
        adminAccountOverallRefresh: false,
        adminPaymentPendingRefresh: false,
        adminPaymentApprovedRefresh: false,
        adminPaymentRejectedRefresh: false,
        adminUsersRefresh: false,
    });


  // Memoize the context value to avoid unnecessary re-renders
  const value = useMemo(() => ({
    sideBarRefresh, setSideBarRefresh,
  }), [
    sideBarRefresh]);

   
     return (
       <SideBarRefreshContext.Provider value={value}>
         {children}
       </SideBarRefreshContext.Provider>
     );
   };
   
   SideBarRefreshContextProvider.propTypes = {
     children: PropTypes.node.isRequired,
   };
   
   export default SideBarRefreshContextProvider;
